import { webDataLoading, webDataNotAsked, webDataSuccess, serializedErrorToWebDataError } from "@lvt/web-data";
import { createSlice } from "@reduxjs/toolkit";

import { fetchLiveUnitsArchives, fetchLiveUnitsStream } from "@/api/liveUnits/liveUnits";
import { RootState } from "@/store";

import { LiveUnitState } from "./types";


const initialState: LiveUnitState = {
    liveUnitsStream: webDataNotAsked(),
    liveUnitsArchives: webDataNotAsked(),
};

export const liveUnitsSlice = createSlice({
    name: "liveUnits",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLiveUnitsStream.pending, (state) => {
                state.liveUnitsStream = webDataLoading();
            })
            .addCase(fetchLiveUnitsStream.fulfilled, (state, action) => {
                state.liveUnitsStream = webDataSuccess(action.payload);
            })
            .addCase(fetchLiveUnitsStream.rejected, (state, action) => {
                state.liveUnitsStream = serializedErrorToWebDataError(action.error);
            })
            .addCase(fetchLiveUnitsArchives.pending, (state) => {
                state.liveUnitsArchives = webDataLoading();
            })
            .addCase(fetchLiveUnitsArchives.fulfilled, (state, action) => {
                state.liveUnitsArchives = webDataSuccess(action.payload);
            })
            .addCase(fetchLiveUnitsArchives.rejected, (state, action) => {
                state.liveUnitsArchives = serializedErrorToWebDataError(action.error);
            });
    },
});

export const liveUnitsReducer = liveUnitsSlice.reducer;
export const liveUnitsSelectors = {
    getLiveUnitsStream: (state: RootState) => {
        return state.liveUnits.liveUnitsStream;
    },
    getLiveUnitsArchives: (state: RootState) => {
        return state.liveUnits.liveUnitsArchives;
    },
};
